export default function toResultMap(list) {
    return list.reduce((acc, item) => {
        acc[item.taskId] = item;
        return acc;
    }, {});
}
